<template>
    <div class="flex justify-between items-center h-20 mb-4 gap-4">
        <div class="min-w-1/4 shrink-0 text-sm text-slate-500">КЛИЕНТЫ</div>
        <input type="text" class="input" />

        <!-- <div class="btn btn-green cursor-pointer gap-2" @click="setPopup('addClient')"><IcoBig name="plus" :size="6" /> Создать</div> -->
    </div>

    <div class="grid grid-cols-4 items-center gap-4">
        <template v-for="item in clients" :key="item.id">
            <div @click="pickClient(item), $router.push('/client')" class="items-center bg-white rounded gap-4 p-8 text-center cursor-pointer">
                <div class="text-xs text-slate-500 mb-4">{{ item.id }}</div>
                <div class="text-md">{{ item.name }}</div>
                <!-- <div class="flex justify-end gap-8" @click="pickClient(item)"><IconEye :size="4" /></div> -->
            </div>
        </template>
    </div>

    <!-- <template v-if="s.popup == 'addClient'"><AddClient /></template> -->
    <!-- <div v-if="s.popup" @click="closePopup()" class="fixed bg-slate-900 z-10 w-screen h-screen top-0 left-0 opacity-80"></div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "ClientsPage",

    data() {
        return {
            month: ["", "января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
            moment: moment,
        };
    },

    computed: {
        ...mapGetters(["s", "clients", "client"]),
    },

    methods: {
        ...mapActions(["getClients", "ClientsPage", "setPopup", "closePopup", "pickClient"]),
    },

    mounted() {
        console.log("Clients Page");

        this.getClients().then(() => {
            this.ClientsPage();
        });
    },
};
</script>
